import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import ParkingCard from '../ParkingCard';

import 'swiper/css';

export default function CardSlider({
    list,
    component
}) {

    // const [startX, setStartX] = useState(undefined)
    // const [startY, setStartY] = useState(undefined)

    // const onMouseDownHandler = (e) => {
    //     setStartX(e.screenX);
    //     setStartY(e.screenY);
    //     e.preventDefault()
    // };

    // const handleOnClick = (e) => {
    //     e.stopPropagation()
    //     if (startX !== e.screenX || startY !== e.screenY) {
    //         e.preventDefault()
    //     }
    // }

    const Component = component || "div";

    return (
        <div className='swiper-container w-300 max-w-300 overflow-x-visible'>
            <Swiper
                spaceBetween={20}
                slidesPerView={1}
            >
                {list?.map((item, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <Component
                                className='block h-full'
                                // onMouseDown={(event) => onMouseDownHandler(event)}
                                // onClick={(event) => handleOnClick(event)}
                                to={item.link}
                            >
                                <ParkingCard
                                    data={item}
                                    fullHeight
                                />
                            </Component>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
        </div>
    )
}
